

<div [formGroup]="form">

  @if (formField.controlType === 'checkbox') {
    <div class="form-group row mt-0 mb-0 align-items-center">
      <label class="col-9 col-form-label col-form-label-sm" [attr.for]="formField.key">
        {{formField.label}}
      </label>
      <div class="col-3">
        <input
          [formControlName]="formField.key"
          [checked]="formField.checked"
          (change)="onCheckboxChange($event)"
          [id]="formField.key"
          [type]="formField.controlType"
          binary="true" />
      </div>
    </div>
  } @else {
    <div class="form-group row mt-0 mb-0">
      <label class="col-12 col-form-label col-form-label-sm fw-bold" [attr.for]="formField.key">
        {{formField.label}}
      </label>
      <div class="col-8">
        @switch (formField.controlType) {
          @case ('textbox') {
            <input
              [formControlName]="formField.key"
              class="form-control form-control-sm border border-primary"
              [placeholder]="formField.placeholder"
              [attr.maxlength]="formField.maxLength ?? null"
              [mask]="formField.mask ?? null"
              [id]="formField.key"
              [type]="formField.inputType"
              [ngStyle]="formField.styles" />
          }
          @case ('tel-mask') {
            <input
              [formControlName]="formField.key"
              phoneMask
              class="form-control form-control-sm border border-primary"
              [placeholder]="formField.placeholder"
              [id]="formField.key"
              [type]="formField.inputType"
              [ngStyle]="formField.styles" />
          }
        }
        @if (form.get(formField.key)?.invalid && form.get(formField.key)?.touched) {
          <div class="text-danger w-100">
            @if (form.get(formField.key)?.errors?.['pattern']) {
              <div>{{ formField.invalidFormatMsg }}</div>
            }
          </div>
        }
      </div>
    </div>
  }

</div>
